import { CONFIG_KEYS, getClientConfigBool } from '../config';
export function incBaseIdentity(path) {
  const prefix = '/account';
  const startsWithSlash = path.slice(0, 1) === '/';

  if (startsWithSlash || path === '') {
    return "".concat(prefix).concat(path);
  } else {
    return "".concat(prefix, "/").concat(path);
  }
}
export function incBaseAccount(path) {
  const prefix = '/account-info';
  const startsWithSlash = path.slice(0, 1) === '/';

  if (startsWithSlash || path === '') {
    return "".concat(prefix).concat(path);
  } else {
    return "".concat(prefix, "/").concat(path);
  }
}
export function incBase(path) {
  return getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_ACCOUNT_NEXT_ENABLED) ? incBaseAccount(path.replace(/\/?account-info/, '')) : incBaseIdentity(path);
}